module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_online_reserve-dac33b33c60472325261991b79f5f03e.svg";